// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/backendFrontend/itemSortingBe.ts

type TSortable = { _id: string; name: string; type: string };
type TSortableSparse = { _id: string; name: string };

const NATURAL_COLLATOR = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

// The collator ignores case and accents, so it returns 0 for names that differ only there.
// The second compare is what then decides their order, and the BE copy must decide it the same way.
export const compareNaturally = (a: string, b: string): number =>
  NATURAL_COLLATOR.compare(a, b) || a.localeCompare(b, 'en');

export const compareItems = (a: TSortable, b: TSortable): number =>
  Number(b.type === 'FOLDER') - Number(a.type === 'FOLDER') ||
  compareNaturally(a.name, b.name) ||
  a.type.localeCompare(b.type, 'en') ||
  a._id.localeCompare(b._id, 'en');

export const compareSparseItems = (a: TSortableSparse, b: TSortableSparse): number =>
  compareNaturally(a.name, b.name) || a._id.localeCompare(b._id, 'en');
